import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap: pxToRem(24),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: pxToRem(4),
    },
    '& .rightPanelAD': {
      flex: '0 0 64.8%',
      maxWidth: '64.8%',
      ...theme.mixins.paddingRight(pxToRem(92)),
      [theme.breakpoints.down('md')]: {
        marginTop: pxToRem(56),
        ...theme.mixins.paddingRight(0),
        flex: '0 0 100%',
        maxWidth: '100%',
      },
      '& .AdStyle': {
        margin: 0,

        '& .tagContainer': {
          display: 'none',
        },
      },
      '& .AdcardRoot': {
        margin: 0,
        '& .price-card': {
          height: pxToRem(152),
          [theme.breakpoints.down('md')]: {
            height: pxToRem(128),
            marginBottom: pxToRem(12),
          },
          '& .AdcardContent': {
            backgroundColor: '#FCEFDE',
            borderColor: '#000',
            borderBottomWidth: '3px',
            transition: 'ease 0.5s all',
            '& .cardContentWrapper': {
              padding: '24px',
              textAlign: 'left',
              [theme.breakpoints.down('md')]: {
                padding: pxToRem(16),
              },
              '& .price-card-title': {
                display: 'flex',
                fontSize: pxToRem(16),
                lineHeight: pxToRem(24),
                minHeight: pxToRem(72),
                width: '100%',
                fontFamily: theme.custom.fontFamily.primaryBold,
                '& h3': {
                  ...theme.palette.common.ellipsis(3),
                },

                [theme.breakpoints.down('md')]: {
                  fontSize: pxToRem(14),
                  marginBottom: pxToRem(8),
                },
              },
              '& .fare': {
                fontSize: pxToRem(14),
                lineHeight: pxToRem(16),
                textAlign: theme.isDirectionRTL ? 'right' : 'left',
                width: '100%',
                color: '#000000'
              }
            },
            '&:hover': {
              borderColor: '#FF8707',
              boxShadow: 'none'
            },
            [theme.breakpoints.down('md')]: {
              '&:hover': {
                borderColor: '#000',
              }
            },
          }
        },

        '& .MuiGrid-root': {
          '& .MuiTypography-h4': {
            lineHeight: 'unset',
          },
        },

        '& .heading': {
          fontSize: pxToRem(32),
          lineHeight: pxToRem(40),
          fontWeight: '700',
          marginBottom: pxToRem(20),

          [theme.breakpoints.down('md')]: {
            marginBottom: pxToRem(14),
          },
        },
        '& .schedule-heading': {
          fontWeight: 'normal',
          '@media (max-width: 768px)': {
            fontSize: pxToRem(26),
            lineHeight: pxToRem(32),
          },

          '@media (max-width: 375px)': {
            fontSize: pxToRem(22),
          },
        },
      },

      '& .DetailedDescription': {
        marginBottom: pxToRem(64),
        '& .richText': {
          fontSize: pxToRem(32),
          lineHeight: pxToRem(40),

          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(20),
            lineHeight: pxToRem(30),
          },

        },
      },
    },
    '& .leftPanelAD': {
      width: '100%',
    }
  },

}));

export default useStyles;
